<template>
    <section class="sectioncontrol">
      <div class="container ">
        <div class="row align-items-start">
          <div class="col" v-for="acsdata in allcardsdata">
            <div class="boxdataimg">
              <img :src="`${myPicUrl}${acsdata.cdsecimage}`" class="sectionimage">
            </div>

              <div  class="slide-info card shadow">
                <div  class="spantext">
                  <p v-html="acsdata.cdsecshortdesc" class="formattitle"></p>
                  <p v-html="acsdata.cdsecdesc" class="desctext"></p>
                  <router-link :to="{ path: acsdata.cdseclink }" class="linktext"><div class="linkspantext">{{ acsdata.cdseclinktext }}<i class="fa-solid fa-square-arrow-up-right linkarrow" style="color: orangered;"></i></div></router-link>
                </div>
              </div>
          </div>
        </div>
      </div>
    </section>
  </template>
 
  <script>
  require('@/globalDeclare.js');
  export default{
   
    props: ['allcardsdata'],
  
    data(){
      return {
        myPicUrl: '',
      }
    },
    mounted() {
      this.myPicUrl = myUrlPath
    }
  }
  </script>
  
  <style scoped>
  img {
    object-fit: cover;
  }
  .newslearnmore {
    float: right; 
    padding-right: 30px;
  }
  .sectioncontrol {
     height: 100%;
     margin-top: 50px;
     margin-bottom: 40px;
     background-color: #fbf8f8;
     padding-bottom: 80px;
  }
  .sectionimage {
    height: 40vh;
    width: 100%;
    z-index: 1;
  }
  .boxdata{
    position: relative;
    width: 350px;
    height: 320px;
    margin-top: -100px;
    margin-right: 50px;
    float: right;
    border: solid orange thick;
    z-index: 1;
  }
  .slide-info {
    background-color: #D0D0D0;
    position: relative;
    margin-top: -120px;
    margin-left: 250px;
    width: 350px;
    height:350px;
    border-radius: 5px;
  }
  .spantext {
    padding-left: 30px;
    padding-right: 30px;
    padding-top: 20px;
    padding-bottom: 20px;
    
  }

  .desctext{
    font-size: 20px;
  }
  .boxdataimg {
    position: relative;
    border: solid thick orange;
    width: 80%;
  }
  .linktext {
    text-decoration: none;
    font-weight: bold;
    float: right;
    color: orangered;
  }
  .linkarrow {
    padding-left: 10px;
    font-size: 26px;
    color: orangered;
  }
  .linkspantext{
    padding-bottom: 20px;
    color: orangered;
  }
.fa-square-arrow-up-right{
  color: orangered;
}
.formattitle {
  font-weight: bold;
  font-size: 24px;
  color: #003;
}

  /*===================MEDIA SCREENS TAMPLATES===============*/
 /* Extra small devices (phones, 600px and down) */
 @media only screen and (max-width: 600px) {
  .sectioncontrol {
    height: 100%;
    margin-top: -100px;
    margin-bottom: 40px;
  }
  .boxdataimg {
    position: relative;
    border: solid thick orange;
    width: 100%;
  }
  .linktext {
    text-decoration: none;
    font-weight: bold;
    float: right;

  }
  .linkarrow {
    padding-left: 10px;
    font-size: 26px;
  
  }
  .linkspantext{
    padding-bottom: 20px;
  }
  .slide-info {
    background-color: #D0D0D0;
    position: relative;
    margin-top: -10px;
    margin-left: auto;
    margin-right: auto;
    width: 330px;
    height:350px;
    border-radius: 5px;
  }
  .col {
    margin-top: 100px;
  }
 }

 /* Small devices (portrait tablets and large phones, 600px and up) */
 @media only screen and (min-width: 600px) {
  .sectioncontrol {
    height: 100%;
    margin-top: 0px;
    margin-bottom: 40px;
  }
  .boxdataimg {
    position: relative;
    border: solid thick orange;
    width: 90%;
  }
  .linktext {
    text-decoration: none;
    font-weight: bold;
    float: right;
   
  }
  .linkarrow {
    padding-left: 10px;
    font-size: 26px;
  
  }
  .linkspantext{
    padding-bottom: 20px;
  }
  .slide-info {
    background-color: #D0D0D0;
    position: relative;
    margin-top: -120px;
    margin-left: auto;
    margin-right: auto;
    width: 350px;
    height:350px;
    border-radius: 5px;
  }
  .col {
    margin-top: 100px;
  }
 }
 
 /* Medium devices (landscape tablets, 768px and up) */
 @media only screen and (min-width: 768px) {
  .sectioncontrol {
    height: 100%;
    margin-top: -50px;
    margin-bottom: 40px;
   }  
  .boxdataimg {
    position: relative;
    border: solid thick orange;
    width: 90%;
  }
  .linktext {
    text-decoration: none;
    font-weight: bold;
    float: right;
 
  }
  .linkarrow {
    padding-left: 10px;
    font-size: 26px;

  }
  .linkspantext{
    padding-bottom: 20px;
  }
  .slide-info {
    background-color: #D0D0D0;
    position: relative;
    margin-top: -120px;
    margin-left: auto;
    margin-right: auto;
    width: 350px;
    height:350px;
    border-radius: 5px;
  }
  .col {
    margin-top: 100px;
  }
 }
 
 /* Large devices (laptops/desktops, 992px and up) */
 @media only screen and (min-width: 992px) {
  .sectioncontrol {
    height: 100%;
    margin-top: -50px;
    margin-bottom: 40px;
   }  
  .boxdataimg {
    position: relative;
    border: solid thick orange;
    width: 90%;
  }
  .linktext {
    text-decoration: none;
    font-weight: bold;
    float: right;

  }
  .linkarrow {
    padding-left: 10px;
    font-size: 26px;
    color: #003;
  }
  .linkspantext{
    padding-bottom: 20px;
  }
  .slide-info {
    background-color: #D0D0D0;
    position: relative;
    margin-top: -120px;
    margin-left: 100px;
    width: 340px;
    height:350px;
    border-radius: 5px;
  }
  .col {
    margin-top: 100px;
  }
 }
 
 /* Extra large devices (large laptops and desktops, 1200px and up) */
 @media only screen and (min-width: 1200px) {
  .sectioncontrol {
    height: 100%;
    margin-top: -50px;
    margin-bottom: 40px;
   }  
  .boxdataimg {
    position: relative;
    border: solid thick orange;
    width: 80%;
  }
  .linktext {
    text-decoration: none;
    font-weight: bold;
    float: right;

  }
  .linkarrow {
    padding-left: 10px;
    font-size: 26px;
    color: orange;
  }
  .linkspantext{
    padding-bottom: 20px;
  }
  .slide-info {
    background-color: #D0D0D0;
    position: relative;
    margin-top: -120px;
    margin-left: 200px;
    width: 340px;
    height:350px;
    border-radius: 5px;
  }
  .col {
    margin-top: 100px;
  }
 } 
</style>